const SummaryTableSchema = [
  {
    objectName: 'customerProductDetailSummary',
    isLoading: 'loadingCustomerProductDetailSummary',
    children: [
      {
        label: 'Product',
        fieldNames: [
          'ProductCode',
          'ProductDescription'
        ],
        valueRenderer: {
          hyperLink: {
            link: false,
            menu: true
          },
          api: {
            api: '/inventoryEnquiry/lookup/action',
            name: 'enquiry',
            params: {
              queryFields: {
                ProductId: 'ProductId',
                SearchText: 'ProductCode'
              }
            }
          }
        }
      },
      {
        label: 'Product Group',
        fieldNames: [
          'ProductGroup',
          'ProductGroupLabel'
        ]
      }
    ]
  },
];

export default SummaryTableSchema;
